@if(!isLoadingShippingGroups() && !shippingGroups.length && _addressShipping){
<!-- Start::mensaje de producto no disponible cuando no hay ningún grupo -->
<div
  class="flex flex-column p-4 mt-3 lg:mt-0 w-full justify-content-center align-items-center h-16rem gap-5 border-1 surface-border border-round"
>
  <div class="flex flex-column align-items-center gap-3">
    <div class="font-semibold text-xl">Producto no disponible</div>
    @if(_shippingType === 'PICKUP' ){
    <span class="text-sm text-center"
      >Este producto no esta disponible para la tienda
      <b>{{ _addressShipping?.city }}</b
      >. Seleccione otra tienda para continuar.</span
    >
    } @else if(_shippingType === 'DELIVERY' ){
    <span class="text-sm text-center"
      >Este producto no esta disponible para entrega a domicilio. Seleccione
      retiro en tienda para continuar.</span
    >
    }
  </div>
  <i class="fa-sharp-duotone fa-solid fa-triangle-exclamation text-6xl"></i>
</div>
<!-- End::mensaje de producto no disponible cuando no hay ningún grupo -->
}

<div class="field mb-4">
  <!-- Start::descripción -->
  @if(shippingGroups.length > 1){
  <p
    class="font-semibold underline mb-4 cursor-pointer"
    (click)="isVisibleSidebarInfo = true"
  >
    Separamos tu pedido en {{ shippingGroups.length }} grupos
  </p>
  }
  <!-- End::descripción -->

  <p-sidebar
    [(visible)]="isVisibleSidebarInfo"
    position="right"
    styleClass="w-screen lg:w-4"
  >
    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-2">
        <span class="font-bold text-lg"> ¿Por qué hay varias entregas? </span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <p>
        Separamos tu compra en múltiples entregas porque hay productos que
        tienen otra fecha de entrega o son enviados desde lugares diferentes
      </p>
      @if(countryCode === 'cl'){
      <p>
        Cada separación generará una Orden de Venta (OV) diferente, las cuales
        recibirás en tu correo electrónico luego de completar la compra.
      </p>
      } @else if(countryCode === 'pe'){
      <p>
        Cada separación generará una Nota de Venta (NV) diferente, las cuales
        recibirás en tu correo electrónico luego de completar la compra.
      </p>
      }
      <p>
        Selecciona cuándo quieres que llegue cada entrega. Recuerda que al
        cambiar tu dirección tus entregas pueden reorganizarse.
      </p>
    </ng-template>
  </p-sidebar>

  @if(isLoadingShippingGroups()){
  <!-- Start::skeleton grupos -->
  <div class="border-round surface-border border-1 mb-4">
    <div
      class="px-3 md:px-4 py-3 border-bottom-1 surface-border flex justify-content-between align-items-center"
    >
      <p-skeleton width="8rem" />
      <div class="flex align-items-center gap-3">
        <p-skeleton width="7rem" />
      </div>
    </div>
    <ul class="list-none p-0 m-0">
      @for(item of [1,2,3]; track $index){
      <li
        class="px-3 md:px-4 py-3 surface-border flex align-items-center gap-3"
        [ngClass]="{ 'border-bottom-1': $index < 2 }"
      >
        <p-skeleton styleClass="w-3rem sm:w-4rem h-3rem sm:h-4rem" />
        <div class="flex flex-column gap-1">
          <p-skeleton width="12rem" />
          <p-skeleton styleClass="sm:28rem" />
          <p-skeleton width="7rem" />
        </div>
        <div
          class="ml-auto flex flex-column justify-content-center align-items-center"
        >
          <p-skeleton width="5rem" />
        </div>
      </li>
      }
    </ul>
    <div
      class="px-4 py-3 border-top-1 surface-border flex justify-content-between align-items-center cursor-pointer"
    >
      <p-skeleton width="12rem" />
      <p-skeleton width="2rem" />
    </div>
  </div>
  <!-- End::skeleton grupos-->

  } @else { @for(group of shippingGroups; track $index){
  <!-- Start::grupos -->
  <div class="border-round surface-border border-1 mb-4">
    <div class="px-4 border-bottom-1 surface-border shipping-group__edge">
      <span class="text-900 font-semibold"
        >Entrega {{ $index + 1 }} de {{ shippingGroups.length }}</span
      >
      <div class="flex align-items-center gap-3">
        <span class="text-900 font-semibold">{{
          group.price | currency
        }}</span>
        @if(shippingGroups.length > 1){
        <p-button
          icon="pi pi-trash"
          severity="danger"
          [text]="true"
          [rounded]="true"
          pTooltip="Eliminar"
          class="delete-button"
          (onClick)="confirmDeleteGroup($event, $index)"
        />
        }
      </div>
    </div>
    <ul class="list-none p-0 m-0">
      @for(product of group.products; track $index){
      <li
        class="px-3 md:px-4 py-3 surface-border flex align-items-center"
        [ngClass]="{ 'border-bottom-1': $index < group.products.length - 1 }"
      >
        <img
          [src]="product.images[150][0]"
          class="w-3rem sm:w-4rem flex-shrink-0 mr-3"
        />
        <div class="flex flex-column">
          <span class="text-900 font-semibold mb-1 text-sm">{{
            product.brand
          }}</span>
          <span class="text-600 mb-1 text-sm">{{ product.name }}</span>
          <span class="text-900 font-medium text-sm">{{ product.sku }}</span>
        </div>
        <div
          class="ml-auto flex flex-column justify-content-center align-items-center"
        >
          <span class="text-900 text-sm text-center">
            {{ product.quantity }}
            {{ product.quantity === 1 ? 'Unidad' : 'Unidades' }}</span
          >
        </div>
      </li>
      }
    </ul>
    <div
      class="px-4 bg-blue-50 border-1 border-primary cursor-pointer border-round-bottom shipping-group__edge"
      (click)="sidebar.show()"
    >
      @if(group.selectedDate){
      <p class="text-900 my-0">
        {{ _shippingType === 'PICKUP' ? 'Retíralo' : 'Recíbelo' }}
        {{ (group.selectedDate.fecha | shippingDate) === 'hoy' ? '' : 'el' }}
        <span class="font-semibold">{{
          group.selectedDate.fecha | shippingDate
        }}</span>
        -
        {{
          group.selectedDate.precio
            ? (group.selectedDate.precio | currency)
            : 'Gratis'
        }}
      </p>
      }

      <i class="fa-sharp fa-solid fa-angle-right text-xl ml-auto"></i>
    </div>

    <app-group-date-sidebar
      #sidebar
      [availableDates]="group.dates"
      [indexGroup]="$index"
      [selectedDateIndex]="group.selectedDate.index"
      (onSubmit)="onSelectDate($event)"
    />
  </div>
  <!-- End::grupos -->

  } }
</div>
<p-confirmDialog />
<p-toast />
